import { imgEmptyList } from '@/assets/images';
import { Stack } from '@/components/layout';
import { Image, Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { createStyles, useScaling } from '@/hooks';
import { guardianColors } from '@/theme/colors';

const strings = STRINGS.guardian.playerSessionHistories;

const SessionHistoryEmptyState = () => {
  const styles = useStyles();
  const { scale } = useScaling();

  return (
    <Stack align="center" style={styles.emptyState}>
      <Image
        source={imgEmptyList}
        width={scale({ phone: 100, tablet: 160 })}
        height={scale({ phone: 90, tablet: 120 })}
        resizeMode="contain"
      />
      <Text variant="Font Guardian App/Subtitle/Subtitle 14 Bold" style={styles.emptyTitle}>
        {strings.emptyTitle}
      </Text>
    </Stack>
  );
};

const useStyles = createStyles(({ scale }) => ({
  emptyState: {
    paddingTop: scale(50),
  },
  emptyTitle: {
    color: guardianColors['6'],
    marginTop: scale(10),
    textAlign: 'center',
  },
}));

export default SessionHistoryEmptyState;
